import { IOption } from 'shared-components';

import { UserRole } from '@/store/auth/types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { ActionSelection } from '../../../types';

export const getEditServicesDropDownOption = (
  userRole: UserRole,
  areAllSelectedStudentsPathwaysEqual: boolean,
  isOnlyPathwayStudents: boolean,
): Array<IOption> => {
  const options: Array<IOption> = [];
  if (hasPerm(userRole, P.EDIT_STUDENT_SERVICES) && areAllSelectedStudentsPathwaysEqual && !isOnlyPathwayStudents) {
    options.push({
      label: 'Services',
      value: ActionSelection.SERVICES,
    });
  }

  return options;
};
